export default function laravelErrorsToListHtml(errors) {
  let errorsArr = errors;

  // Laravel validation will return errors as an object with a key per field
  // and an array of errors per field.
  if (!Array.isArray(errorsArr)) {
    const errorsFromObject = [];

    Object.keys(errorsArr).forEach((key) => {
      errorsArr[key].forEach((error) => {
        errorsFromObject.push(error);
      });
    });

    errorsArr = errorsFromObject;
  }

  return errorsArr.map((error) => (
    `<li>${error}</li>`
  )).join('');
}
